import React, { useState } from 'react';
import { copyText, userBioLines, userLocationLines, userPhotoCountLabel, userPhotoList } from '../../../adminApi';

function UserPreview(props) {
  const user = props.user;
  const photos = userPhotoList(user);
  const [index, setIndex] = useState(0);
  const photo = photos[index];
  const bio = userBioLines(user);

  if (!user) {
    return null;
  }

  return (
    <div className="admin-preview" onClick={props.onClose} role="presentation">
      <div className="admin-preview__card" onClick={(event) => event.stopPropagation()} role="dialog" aria-label="Profile preview">
        <div className="admin-section-head">
          <div>
            <h2>
              {user.name || 'Unknown'}{user.age != null ? ` | ${user.age}` : ''}
              {user.profileVerified ? ' ✓' : ''}
            </h2>
            <p className="admin-muted">{user.active === 'false' ? 'Disabled' : 'Active'}</p>
          </div>
          <button type="button" className="admin-btn" onClick={props.onClose}>Close</button>
        </div>
        <div className="admin-preview__photo">
          {photo ? <img src={photo.url} alt={user.name || 'Profile'} /> : <div className="admin-card__empty">No photo</div>}
        </div>
        {photos.length > 1 ? (
          <div className="admin-actions">
            <button type="button" className="admin-btn" onClick={() => setIndex((current) => (current === 0 ? photos.length - 1 : current - 1))}>
              Previous
            </button>
            <button type="button" className="admin-btn" onClick={() => setIndex((current) => (current === photos.length - 1 ? 0 : current + 1))}>
              Next
            </button>
          </div>
        ) : null}
        <div className="admin-preview__meta">
          <div>{[user.gender, user.genderPreference].filter(Boolean).join(' → ') || 'No gender'}</div>
          <div>{user.ethnicity || 'No ethnicity'}</div>
          <div>{user.email || 'No email'}</div>
          <div>{user.phoneNumber || user.loginCredential || 'No number'}</div>
          <div>{userPhotoCountLabel(user)}</div>
          {userLocationLines(user).map((line) => (
            <div key={line}>{line}</div>
          ))}
        </div>
        <div className="admin-actions">
          <button type="button" className="admin-btn" onClick={() => copyText(user.userId)}>UserID</button>
          {user.email ? <button type="button" className="admin-btn" onClick={() => copyText(user.email)}>Copy email</button> : null}
          {user.loginCredential ? <button type="button" className="admin-btn" onClick={() => copyText(user.loginCredential)}>Copy credential</button> : null}
        </div>
        <dl className="admin-preview__bio">
          {bio.map((line) => (
            <React.Fragment key={`${line.label}-${line.value}`}>
              <dt>{line.label}</dt>
              <dd>{line.value}</dd>
            </React.Fragment>
          ))}
        </dl>
        {bio.length === 0 ? <p className="admin-muted">No bio details.</p> : null}
      </div>
    </div>
  );
}

export default UserPreview;
